export default {
  components: {},
  add(name: string, component: React.ReactNode): void {
    this.components[name] = component;
  },
  get(name: string): React.ReactNode | Record<string, string> {
    return this.components[name];
  },
};
